import React from 'react';
import { classNames } from '../../utils/style';
import { Image } from '../../components/Image';
import {
  textBody,
  textBodyLarge,
  textUppercaseCaption,
} from '../../styles/typography';

import { animationImage, applyCardStyle, transitionAnimation } from './logic';
import { CardProps } from '.';

export const MultipleBlogsCard = ({
  type,
  className,
  capsText,
  image,
  title,
  subtitle,
  text,
  as: Component = 'div',
  children,
}: CardProps) => {
  return (
    <Component
      className={classNames(
        'Card MultipleBlogsCard rounded-18 flex flex-col overflow-hidden bg-neutral-1',
        applyCardStyle(type),
        className,
      )}
    >
      {image && (
        <div className="BlogImage aspect-4/3 overflow-hidden">
          <Image
            dragable={false}
            {...image}
            className={classNames(
              'h-full object-cover object-top',
              transitionAnimation,
              animationImage,
            )}
            sizes={['(min-width: 1280px) 400px', '360px']}
          />
        </div>
      )}
      {(capsText || title || subtitle) && (
        <div
          className={`py-32 px-24 flex flex-col  flex-shrink-0 ${
            capsText ? 'h-1/2 ' : 'h-2/5'
          }`}
        >
          {capsText && (
            <span
              className={classNames(
                textUppercaseCaption,
                `uppercase text-neutral-101 font-medium mb-24`,
              )}
            >
              {capsText}
            </span>
          )}
          {title && (
            <p
              className={classNames(
                textBodyLarge,
                `text-neutral-301 font-medium mb-8`,
              )}
            >
              {title}
            </p>
          )}
          {subtitle && (
            <p className={classNames(textBody, `text-neutral-301`)}>
              {subtitle}
            </p>
          )}
          {text && (
            <p className={classNames(textBody, `text-neutral-301`)}>{text}</p>
          )}
          {children}
        </div>
      )}
    </Component>
  );
};
export default MultipleBlogsCard;
